module.exports = __webpack_public_path__ + "img/sb08.b08e32a1.png";